import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";
import styles from "./SearchToggle.module.scss";
import { clsx } from "clsx";

interface SearchToggleProps {
  activeTab: "library" | "sample";
}

export default function SearchToggle({ activeTab }: SearchToggleProps) {
  return (
    <>
      <h1 className={styles.searchTitle}>
        <FormattedMessage defaultMessage="Discover Free Samples or Search in My Library" />
      </h1>
      <div className={styles.pillToggle} role="group">
        <NavLink
          to="/search/sample"
          className={clsx(
            styles.pillToggleOption,
            activeTab === "sample" && styles.pillToggleOptionSelected
          )}
        >
          <FormattedMessage defaultMessage="Search for Samples" />
          <span className={styles.betaTag}>
            <FormattedMessage defaultMessage="Beta" />
          </span>
        </NavLink>

        <NavLink
          to="/search/library"
          className={clsx(
            styles.pillToggleOption,
            activeTab === "library" && styles.pillToggleOptionSelected
          )}
        >
          <FormattedMessage defaultMessage="Search in My Library" />
        </NavLink>
      </div>
    </>
  );
}
